
import { Component, Vue } from "vue-property-decorator";
import { RegisterRouter } from "@root/core/router";
import { toEnumInterface } from "@root/core";
import { BaseView } from "@root/components";
import { ProjectView } from "@/views/project-view";

@Component
export default class extends ProjectView {
    get table_client_inf() {
        return require("raw-loader!./table-client.interface").default;
    }
    get table_client_data() {
        return require("./table.data").data;
    }

    get table_server_params() {
        return {
            orderBy: [{ role1: "asc" }, { username: "asc" }],
        };
    }
    get table_server_inf() {
        return require("raw-loader!./table-server.interface").default;
    }

    private role2_converter(value) {
        return "ROLE2";
    }
}
